module.exports = __webpack_public_path__ + "img/20200118115351911.19fb640f.jpg";